import { processRequest } from '../../services/Api';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import i18n from 'i18next';
import { sharedTypes } from './Constants';
import { COOKIES, UPGRADE_MODALS_IDENTIFIER } from '../../services/Constants';
import { getCookie } from '../../services/Helper';
import * as sharedActions from './Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as sidebarActions from '../../components/sideBar/Actions';
import * as notificationActions from '../../components/notification/Actions';

export default function* () {
	yield all([
		takeLatest(sharedTypes.SEND_EVENT_REQUEST, handleSendEventRequest),
		takeLatest(sharedTypes.SET_THEME, handleSwitchTheme),
		takeLatest(sharedTypes.GET_USER_COLLECTIONS, handleGetUserCollectionsRequest),
		takeLatest(sharedTypes.GET_USER_SUGGESTED_SUBJECTS, handleGetUserSuggestedSubjectsRequest),
		takeLatest(sharedTypes.GET_TFA_DATA, handleGetTFADataRequest),
		takeLatest(sharedTypes.SET_TFA_CODE, handleSetTFACodeRequest),
	]);
}

export function* handleSendEventRequest({ payload }) {
	try {
		const { data: requestData, callback } = payload;
		yield call(processRequest, `send_event`, 'POST', requestData);

		if (requestData.feature === UPGRADE_MODALS_IDENTIFIER.TUTOR_CHAT_STARTED) {
			yield put(sharedActions.sendEventSuccess({ triggerMessagePresent: true }));
		}

		if (callback) callback();
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
	}
}

export function* uploadFileHelper(endpoint, file) {
	const { name = '', type } = file || {};
	const fileExtension = name.substring(name.lastIndexOf('.') + 1);

	const { data } = yield call(
		processRequest,
		`${endpoint}/presigned_image_url?content_type=${type}&file_extension=${fileExtension}`,
	);
	const { signed_url = '' } = data || {};

	yield call(processRequest, signed_url, 'PUT', file, true);

	return { linkToFile: signed_url.split('?')[0], fileName: name };
}

export function* handleSwitchTheme({ payload }) {
	try {
		const { selectedThemeOption, userId } = payload || {};
		if (userId) {
			yield call(processRequest, `users/${userId}`, 'PUT', {
				user: { selected_theme: selectedThemeOption },
			});

			yield put(sidebarActions.updateUserDataTheme(selectedThemeOption));
		}
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
	}
}

export function* handleGetUserCollectionsRequest({ payload }) {
	try {
		const { type } = payload || {};

		const filteredType = ['books', 'groups', 'folders'].find((el) => el === type);

		const { data } = yield call(
			processRequest,
			`get_user_data/added_items${filteredType ? `?item_type=${filteredType}` : ''}`,
		);

		yield put(sharedActions.getUserCollectionsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(sharedActions.getUserCollectionsError());
	}
}

export function* handleGetUserSuggestedSubjectsRequest() {
	try {
		const { data } = yield call(processRequest, 'subjects/suggested_subjects');

		yield put(sharedActions.getUserSuggestedSubjectsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(sharedActions.getUserSuggestedSubjectsError());
	}
}

export function* handleGetTFADataRequest({ payload }) {
	const { errorCallback } = payload || {};

	try {
		const { data } = yield call(processRequest, 'auth/setup_mfa', 'GET', {}, false, false, {
			'X-MFA-Token': getCookie(COOKIES.mfaAccessToken) || '',
		});
		yield put(sharedActions.getTFADataSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(sharedActions.getTFADataError());
		if (errorCallback) errorCallback(e);
	}
}

export function* handleSetTFACodeRequest({ payload }) {
	const { code: totp_code, callback, errorCallback } = payload || {};

	try {
		const { data } = yield call(
			processRequest,
			'auth/confirm_mfa',
			'POST',
			{
				totp_code,
			},
			false,
			false,
			{
				'X-MFA-Token': getCookie(COOKIES.mfaAccessToken) || '',
			},
		);
		yield put(sharedActions.setTFACodeSuccess());
		yield put(
			notificationActions.createNotification(i18n.t('notifications.tfa_success_setup')),
		);

		if (callback) callback(data);
	} catch (e) {
		const { response } = e || {};
		const { status } = response || {};

		if (status === 401) {
			if (errorCallback) errorCallback(response);
		} else {
			yield put(errorHandlerActions.handleError(e, 'notification'));
		}

		yield put(sharedActions.setTFACodeError());
	}
}
